module.exports = __webpack_public_path__ + "img/trash-icon.aab69856.svg";